// The catalogue barrel.
//
// EN is the SOURCE catalogue (the doctor-app rule, docs/I18N.md there): every
// key is declared in en.js and fa.js translates it. A fa-only key is a defect,
// and tests/i18n.test.js asserts parity in both directions.
//
// Persian is the PRODUCT language: this panel is for Iranian medical students
// and every screen ships complete Persian copy. English exists because the
// source catalogue is the reviewable record of what the app says.
//
// Both halves live in ./translations/ so a screen's copy can be reviewed
// without scrolling past the mechanism.
//
// One flat map per locale, with fully qualified dotted keys, rather than the
// doctor app's namespace-per-file + lazy loader. This app has six screens and
// one bundle; the loader's job — not shipping fifteen JSON files to render one
// screen — does not exist here yet. The KEY SHAPE is identical, so promoting to
// the namespaced loader later is a mechanical move that touches no screen.

import { en } from './translations/en.js';
import { fa } from './translations/fa.js';

export { en, fa };

export const catalogs = { en, fa };
